import { PartnerPermissionName } from 'api/partner/types';
import { TranslationKey } from 'hooks/use-translation';
import { AccountPermissionSetType } from 'stores/permission-sets';
import { unreachable } from 'utils/unreachable';

export const translationKeyForAccessLevelLabel = (
  accessLevel: PartnerPermissionName,
): TranslationKey => {
  switch (accessLevel) {
    case PartnerPermissionName.Permissive:
      return 'partners.access_level.permissive.label';
    case PartnerPermissionName.Moderate:
      return 'partners.access_level.moderate.label';
    case PartnerPermissionName.Restricted:
      return 'partners.access_level.restricted.label';
    default:
      return unreachable(accessLevel);
  }
};

export const translationKeyForAccessLevelDescription = (
  accessLevel: PartnerPermissionName,
): TranslationKey => {
  switch (accessLevel) {
    case PartnerPermissionName.Permissive:
      return 'partners.access_level.permissive.description';
    case PartnerPermissionName.Moderate:
      return 'partners.access_level.moderate.description';
    case PartnerPermissionName.Restricted:
      return 'partners.access_level.restricted.description';
    default:
      return unreachable(accessLevel);
  }
};

export const translationKeyForPartnerMemberPermissionLabel = (
  permissionSetType: AccountPermissionSetType,
): TranslationKey => {
  switch (permissionSetType) {
    case AccountPermissionSetType.PartnerAdmin:
      return 'partners.team_members.permission.partner_admin.label';
    case AccountPermissionSetType.PartnerCollaborator:
      return 'partners.team_members.permission.partner_collaborator.label';
    case AccountPermissionSetType.PartnerMember:
      return 'partners.team_members.permission.partner_member.label';
    default:
      return unreachable(permissionSetType as never);
  }
};

export const translationKeyForPartnerMemberPermissionDescription = (
  permissionSetType: AccountPermissionSetType,
): TranslationKey => {
  switch (permissionSetType) {
    case AccountPermissionSetType.PartnerAdmin:
      return 'partners.team_members.permission.partner_admin.description';
    case AccountPermissionSetType.PartnerCollaborator:
      return 'partners.team_members.permission.partner_collaborator.description';
    case AccountPermissionSetType.PartnerMember:
      return 'partners.team_members.permission.partner_member.description';
    default:
      return unreachable(permissionSetType as never);
  }
};
